import { CandidateInfoComponent } from "./../theory-assessment/candidate-info/candidate-info.component";
import { environment } from "./../../environments/environment";
import { Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import html2canvas from "html2canvas";
import * as moment from "moment";
import * as videojs from "video.js";
import { MatDialog } from "@angular/material/dialog";

import { SynDatewithServerService } from "../service/syn-datewith-server.service";

var option, route: any;
var id = 0;
var count: number;
var localstream: any;
var count_cam: number = 0;
var full_screen;
var visibility;
var index: number;
var sec: number;
var quest;
var fullscreen = 0;
var exit_full_screen = 0;
var attempted_count: any;
var marked_review = 0;
let timer = false;
var id1, id2, id3, id4;
var varCandidateAssessmentData: any;
var EventImage = "";
declare var window: any;
var constraints = {
  video: {
    facingMode: "user",
    width: 1280,
    height: 720,
  },
  audio: false,
};

declare var cam: any;
@Component({
  selector: "app-practical-assessment",
  templateUrl: "./practical-assessment.component.html",
  styleUrls: ["./practical-assessment.component.css"],
})
export class PracticalAssessmentComponent implements OnInit {
  Req: any;
  Id: any;
  data: any;
  record_state: any;
  isFirefox: any;

  Clientdata: any;
  clientInfo: any;
  isMobile = false;

  LeftTime: any = JSON.parse(
    localStorage.getItem(
      localStorage.getItem("req_id") +
        "_" +
        localStorage.getItem("cand_id") +
        "_" +
        "data"
    )
  ).CandidateAssessmentData.PracticalAssessment.RemainingDurationSeconds;
  time_array: any = [];

  constructor(
    private route: Router,
    private synDatewithServerService: SynDatewithServerService,
    public dialog: MatDialog
  ) {
    var left = this.LeftTime;
    while (left >= 2) {
      this.time_array.push(left - 1);
      left -= 1;
    }
  }

  ngOnInit(): void {
    this.Req = localStorage.getItem("req_id");
    this.Id = localStorage.getItem("cand_id");
    this.data = JSON.parse(
      localStorage.getItem(this.Req + "_" + this.Id + "_" + "data")
    );

    console.log("this.data", this.data);

    localStorage.setItem("assessment", "practical");

    this.synDatewithServerService.startAsyc();

    if (isMobile.any()) {
      this.isMobile = true;
    }
    this.Clientdata = localStorage.getItem("clieInfo");
    this.clientInfo = JSON.parse(this.Clientdata);

    localStorage.setItem("Video_upload_url", environment.Upload_files_URL);
    varCandidateAssessmentData = this.data;
    console.log("varCandidateAssessmentData", varCandidateAssessmentData);
    let secCount =
      varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
        .CurrentSectionIndex;
    let indexCount =
      varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
        .CurrentQuestionIndex;
    let countsave =
      varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
        .CurrentQuestionCount;

    console.log(secCount, countsave, indexCount);

    sec = secCount ? secCount : 0;
    count = countsave ? countsave : 1;
    index = 0;

    console.log(sec, count, index);

    route = this.route;

    $(function () {
      if (
        varCandidateAssessmentData.CandidateAssessmentData
          .EnablePartialSubmission == false
      ) {
        $("#submit_reponse_btn").attr("disabled", "disabled");
        Finish_check(varCandidateAssessmentData);
      }
      for (
        var i = 0;
        i <
        parseInt(
          varCandidateAssessmentData.CandidateAssessmentData.Languages.length
        );
        i++
      ) {
        document.getElementById(
          varCandidateAssessmentData.CandidateAssessmentData.Languages[i]
            .LanguageName
        ).style.display = "block";
      }
    });

    var id = $("#card").attr("id");
    let nos = 1;
    var i_length =
      varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
        .Sections.length;

    if (
      parseInt(
        varCandidateAssessmentData.CandidateAssessmentData.CandidateAttemptCount
      ) > 1
    ) {
      attempted_count = 0;
      marked_review = 0;
      var key: string = "";
      $(document).keydown(function (e) {
        key = e.key;
      });
      Event_log(
        "ASSESSMENT_CONTINUED",
        varCandidateAssessmentData,
        sec,
        index,
        key
      );
    } else if (
      parseInt(
        varCandidateAssessmentData.CandidateAssessmentData.CandidateAttemptCount
      ) == 1
    ) {
      var key: string = "";
      $(document).keydown(function (e) {
        key = e.key;
      });
      Event_log(
        "ASSESSMENT_STARTED",
        varCandidateAssessmentData,
        sec,
        index,
        key
      );
    }

    for (let i = 0; i < i_length; i++) {
      $("#card").append(
        '<div class="row justify-content-center">' +
          '<p class="card-text">Section-' +
          (i + 1) +
          "</p><br /></div>" +
          '<div class="row justify-content-center">'
      );
      var j_length =
        varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
          .Sections[i].Questions.length;
      for (let j = 0; j < j_length; j++) {
        console.log("i", "j", i, j);

        var ids = "sec" + (i + 1) + "_" + (j + 1);
        var vid_id = "video" + (i + 1) + "_" + (j + 1);

        console.log("sec", ids);

        $("#card").append(
          '<button id="' +
            ids +
            '" type= "button" class="btn btn-danger px-3" value="' +
            nos +
            '" >' +
            nos +
            "</button>"
        );
        $("#vid").append(
          '<video id="' +
            vid_id +
            '"class="video-js vjs-default-skin" style="display: none"></video>'
        );

        console.log("i", "j", i, j);

        this.isQuestionAnswered(i, j);

        nos += 1;
      }
      $("#card").append("</div>");
    }

    let clicked = this.clicked;

    $(function () {
      $("button").click(function () {
        var self = this;
        if (this.id.startsWith("sec")) {
          let section = this.id.split("_");
          // self.isQuestionAnswered()
          clicked(
            section[0].charAt(section[0].length - 1),
            section[1],
            this.textContent as string
          );
        }
      });
    });
    var VideoContent = {
      VideoArray: [],
    };
    // document.addEventListener(
    //   "contextmenu",
    //   (id4 = (event: any) => event.preventDefault())
    // );
    // $("body").on("cut copy paste", function (e) {
    //   e.preventDefault();
    // });

    let datas: any = this.data;

    $(function () {
      if (
        datas.CandidateAssessmentData.PracticalAssessment
          .AssessmentStartDateTime == ""
      )
        datas.CandidateAssessmentData.PracticalAssessment.AssessmentStartDateTime =
          moment().format("DD-MMM-YYYY h:mm:ss a");
      $("#dropdown").change(function () {
        var key: string = "";
        $(document).keydown(function (e) {
          key = e.key;
        });
        Event_log(
          "QUESTION_LANGUAGE_CHANGED",
          varCandidateAssessmentData,
          sec,
          index,
          key
        );
      });
      /*$.each(
        datas.CandidateAssessmentData.PracticalAssessment.Sections,
        function (index: number, value) {
          $.each(
            datas.CandidateAssessmentData.PracticalAssessment.Sections[index]
              .Questions,
            function (ind: number, values) {
              if (
                datas.CandidateAssessmentData.PracticalAssessment.Sections[
                  index
                ].Questions[ind].CandidateActualResponseOption != "-1"
              ) {
                var sections = "sec" + (index + 1) + "_" + (ind + 1);
                document.getElementById(sections).className =
                  "btn btn-success px-3";
              }
            }
          );
        }
      );*/
    });
    var minutes = Math.floor(3600 / 60);
    var seconds = 3600 - minutes * 60;

    if (!this.isMobile) {
      document.getElementById("info1").innerHTML =
        "<b>Candidate Name : " +
        this.data.CandidateAssessmentData.CandidateName +
        "</b>" +
        "<br/>" +
        "<b>Registration Id : " +
        this.data.CandidateAssessmentData.RegistrationId +
        "</b>";
      document.getElementById("info2").innerHTML =
        "<b>Job : " +
        this.data.CandidateAssessmentData.QualificationPackName +
        "</b>" +
        "<br/>" +
        "<b>Sections & Duration : " +
        this.data.CandidateAssessmentData.PracticalAssessment.Sections.length +
        " , " +
        minutes +
        " m : " +
        seconds +
        " s" +
        "</b>";
      ("</b>");

      document.getElementById("info3").innerHTML =
        "<b>Question Paper Title : " +
        this.data.CandidateAssessmentData.QuestionPaperTitle +
        "</b>" +
        "<br/>";
    }

    // sec = 0;
    // count = 1;
    varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment.AssessmentStatusId =
      environment.ASSESSMENT_IN_PROGRESS;

    id3 = setInterval(() => {
      localStorage.setItem(
        this.Req + "_" + this.Id + "_" + "data",
        JSON.stringify(varCandidateAssessmentData)
      );
      localStorage.setItem(
        "Response_data",
        JSON.stringify(varCandidateAssessmentData)
      );
    }, 5000);

    this.isFirefox = this.myBrowser();

    if (this.isFirefox === "Firefox") {
      this.onInitFs();
    } else {
      window.requestFileSystem =
        window.requestFileSystem || window.webkitRequestFileSystem;
      window.requestFileSystem(
        window.TEMPORARY,
        1000 * 1024 * 1024,
        this.onInitFs,
        errorHandler
      );
    }
    this.initial();
  }

  storeData(sec: any, index: any, count: any) {
    console.log(sec, index, count, "sss");

    varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment.CurrentSectionIndex =
      sec;
    varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment.CurrentQuestionIndex =
      index;
    varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment.CurrentQuestionCount =
      count;
    localStorage.setItem(
      localStorage.getItem("req_id") +
        "_" +
        localStorage.getItem("cand_id") +
        "_" +
        "data",
      JSON.stringify(varCandidateAssessmentData)
    );

    const data = JSON.parse(
      localStorage.getItem(this.Req + "_" + this.Id + "_" + "data")
    );

    console.log("data", data);
  }

  showSection = true;

  showSectionLink() {
    this.showSection = !this.showSection;

    if (this.showSection) {
      document.getElementById("PracticalSec").style.display = "block";
    } else {
      document.getElementById("PracticalSec").style.display = "none";
    }
  }

  openDialog(): void {
    let dialogRef = this.dialog.open(CandidateInfoComponent, {
      width: "500px",
      height: "368px",
      data: { data: this.data },
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  myBrowser() {
    if (
      (navigator.userAgent.indexOf("Opera") ||
        navigator.userAgent.indexOf("OPR")) != -1
    ) {
      return "Opera";
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
      return "Chrome";
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      return "Safari";
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      return "Firefox";
    } else if (navigator.userAgent.indexOf("MSIE") != -1) {
      return "IE";
    } else {
      return "unknown";
    }
  }

  Uploadfiles(img: any) {
    console.log("img", img);

    var varFormData = new FormData();
    varFormData.append("image_file_name", img.FileName);
    varFormData.append("image_data", img.Image_Data);
    var res;
    $.ajax({
      url: environment.Upload_files_URL,
      type: "POST",
      data: varFormData,
      contentType: false,
      cache: false,
      processData: false,
      async: false,
      success: function (response) {
        res = response;
      },
      error: function (e) {},
    });
    //return res;
  }

  selectedFile: any;

  isVideoinput = true;
  showUploadInput = false;
  fileLimitExceed = false;
  isUploaded = false;

  uploadVideo() {
    this.isVideoinput = false;
    this.showUploadInput = false;
  }

  uploadEvidence() {
    this.isVideoinput = true;
    this.showUploadInput = true;
    this.isUploaded = false;
    document.getElementById("fileuploadBox").style.display = "block";
  }

  reset() {
    if (
      confirm(
        "You are about to remove all uploaded files for this questions. Do you want to continue?"
      ) == false
    ) {
      return true;
    }
    this.isVideoinput = true;
    this.showUploadInput = false;
    // this.fileLimitExceed = false;
    this.isUploaded = false;
    var sections = "sec" + (sec + 1) + "_" + (index + 1);
    document.getElementById(sections).className = "btn btn-danger px-3";
    varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment.Sections[
      sec
    ].Questions[index].CandidateActualResponseOption = "1";

    // varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment.Sections[
    //   sec
    // ].Questions[index].CandidateResponseEvidenceList = [];

    localStorage.setItem(
      "Response_data",
      JSON.stringify(varCandidateAssessmentData)
    );
  }

  revert() {
    this.isVideoinput = true;
    this.showUploadInput = false;
    // this.fileLimitExceed = false;
    this.isUploaded = false;
  }

  processFileNew(imageInput: any) {
    this.isUploaded = false;
    const Files = (File = imageInput.files);
    for (let i = 0; i < Files.length; i++) {
      const reader = new FileReader();
      reader.readAsDataURL(Files[i]);
      reader.onload = () => {
        this.UploadAnswerSheets(Files[i], reader.result);
      };
    }
  }

  UploadAnswerSheets(file: any, data: any) {
    let dataValue = varCandidateAssessmentData.CandidateAssessmentData;
    let extentions = file.type;
    let exctExtension = extentions.replace(/(.*)\//g, "");
    let acceptiableFiletype = ["pdf", "png", "jpeg", "JPG"]; //"docx"
    if (!acceptiableFiletype.includes(exctExtension)) {
      alert("We are only support png, pdf, jpeg file format");
      return true;
    }
    const fileName =
      dataValue.CandidateId +
      "_" +
      dataValue.RegistrationId +
      "_PracticalEvidence_" +
      moment().format("YYYYMMDDhhmmss") +
      "." +
      exctExtension;
    var varFormData = new FormData();
    varFormData.append("image_file_name", fileName);
    varFormData.append("image_data", data);
    varFormData.append("evidence_status", "1");
    ///  eviden

    var self = this;
    var res;
    $.ajax({
      url: environment.Upload_files_URL,
      type: "POST",
      data: varFormData,
      contentType: false,
      cache: false,
      processData: false,
      async: false,
      success: function (response) {
        res = JSON.parse(response);
        console.log("res", res);
        if (res.response_file_status) {
          var sections = "sec" + (sec + 1) + "_" + (index + 1);
          self.isUploaded = true;
          document.getElementById(sections).className = "btn btn-success px-3";

          let dataPractical =
            varCandidateAssessmentData.CandidateAssessmentData
              .PracticalAssessment;

          dataPractical.Sections[sec].Questions[
            index
          ].CandidateActualResponseOption = "1";

          var evidenceObj = {
            Filename: "",
            TimeStamp: moment().format("YYYYMMDDhhmmss"),
            Latitude: "",
            Longitude: "",
          };

          evidenceObj.Filename = fileName;
          let lat = localStorage.getItem("lat");
          let long = localStorage.getItem("long");

          evidenceObj.Latitude = lat as string;
          evidenceObj.Longitude = long as string;

          dataPractical.Sections[sec].Questions[
            index
          ].CandidateResponseEvidenceList.push(evidenceObj);

          console.log(
            "ssss",
            dataPractical.Sections[sec].Questions[index]
              .CandidateResponseEvidenceList
          );

          dataPractical.Sections[sec].Questions[
            index
          ].CandidateResponseVideoFileName = "";

          localStorage.setItem("Response_data", JSON.stringify(dataPractical));
          self.isUploaded = true;
        }
      },
      error: function (e) {},
    });
    return res;
  }

  onInitFs(fs?: any) {
    let self = this;
    let data = varCandidateAssessmentData;
    var ImageArrayObj;
    let lat = localStorage.getItem("lat");
    let long = localStorage.getItem("long");

    //visibility change
    document.addEventListener(
      "keydown 1 ",
      (visibility = function () {
        $.ajax({
          url: environment.Violation_Api,
          type: "POST",
          dataType: "json",
          data: {
            ApiKey: environment.api_key,
            CandidateId:
              varCandidateAssessmentData.CandidateAssessmentData.CandidateId,
            RequestId:
              varCandidateAssessmentData.CandidateAssessmentData
                .AssessmentRequestId,
            ViolationCode: "APP_SWITCHING",
          },
          success: function (data) {},
        });

        const maxAppSwitchCount =
          varCandidateAssessmentData.CandidateAssessmentData
            .MaximumAppSwitchingCount;

        if (exit_full_screen > maxAppSwitchCount) {
          exit_full_screen = 0;
        }
        exit_full_screen += 1;
        var key: string = "";
        $(document).keydown(function (e) {
          key = e.key;
        });
        $("#popup").css({
          opacity: 1,
        });
        if (exit_full_screen == maxAppSwitchCount) {
          document.getElementById("message").innerHTML =
            "<h1>" +
            "Unauthorized key pressed<br><br>You only have no chances left<br>" +
            "</h1>";
        } else if (exit_full_screen < maxAppSwitchCount) {
          document.getElementById("message").innerHTML =
            "<h1>" +
            "Unauthorized key pressed<br><br>You only have " +
            (maxAppSwitchCount - exit_full_screen) +
            " chances left<br>" +
            "</h1>";
        }
        $(".fullscreen-container").fadeTo(200, 1);
        $("#ok").click(function () {
          if (exit_full_screen < maxAppSwitchCount) {
            $("#popup").css({
              opacity: 0,
            });
            $(".fullscreen-container").fadeOut(200);
            var docElm = document.documentElement;
            if (docElm.requestFullscreen) {
              docElm.requestFullscreen();
            }
          } else if (exit_full_screen >= maxAppSwitchCount) {
            $("#popup").css({
              opacity: 1,
            });
            document.getElementById("message").innerHTML =
              "<h1>" + "You have violated the rules<br>" + "</h1>";
            $(".fullscreen-container").fadeTo(200, 1);
            $("#ok").click(function () {
              exit_full_screen = 0;
              fullscreen = 0;
              route.navigate(["login"]);
            });
          }
        });
        html2canvas(document.body).then(function (canvas: any) {
          var ScreenshotImage = {
            Filename: "",
            TimeStamp: "",
            Latitude: "",
            Longitude: "",
          };
          ScreenshotImage.Filename =
            "REG" +
            varCandidateAssessmentData.CandidateAssessmentData.RegistrationId +
            "_PracticalViolation_" +
            moment().format("YYYYMMDDhhmmss") +
            ".jpeg";
          ScreenshotImage.TimeStamp = moment().format("DD-MMM-YYYY h:mm:ss a");
          ScreenshotImage.Latitude = lat as string;
          ScreenshotImage.Longitude = long as string;
          ImageArrayObj = {
            FileName: "",
            Image_Data: "",
          };
          ImageArrayObj.FileName = ScreenshotImage.Filename;
          ImageArrayObj.Image_Data = canvas.toDataURL("image/jpeg");
          EventImage = ImageArrayObj.FileName;
          Event_log("TAB_SWITCH", data, sec, index, key);
          //ImageArrayContent.ImageArray.push(ImageArrayObj);
          //localStorage.setItem('Image_Array', JSON.stringify(ImageArrayContent));
          varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment.ScreenshotImages.push(
            ScreenshotImage
          );
          if (self?.isFirefox === "Firefox") {
            self.Uploadfiles(ImageArrayObj);
          } else {
            WriteFileToFileSystem(
              fs,
              ImageArrayObj.FileName,
              ImageArrayObj.Image_Data
            );
          }
        });
      })
    );

    //  fullscreen change
    document.addEventListener(
      "fullscreenchange",
      (full_screen = function (event: any) {
        fullscreen += 1;
        var key: string = "";
        $(document).keydown(function (e) {
          key = e.key;
        });
        html2canvas(document.body).then(function (canvas: any) {
          var ScreenshotImage = {
            Filename: "",
            TimeStamp: "",
            Latitude: "",
            Longitude: "",
          };
          ScreenshotImage.Filename =
            "REG" +
            varCandidateAssessmentData.CandidateAssessmentData.RegistrationId +
            "_PracticalViolation_" +
            moment().format("YYYYMMDDhhmmss") +
            ".jpeg";
          ScreenshotImage.TimeStamp = moment().format("DD-MMM-YYYY h:mm:ss a");
          ScreenshotImage.Latitude = lat as string;
          ScreenshotImage.Longitude = long as string;
          ImageArrayObj = {
            FileName: "",
            Image_Data: "",
          };
          ImageArrayObj.FileName = ScreenshotImage.Filename;
          ImageArrayObj.Image_Data = canvas.toDataURL("image/jpeg");
          EventImage = ImageArrayObj.FileName;
          Event_log("EXIT_FULLSCREEN", data, sec, index, key);
          //ImageArrayContent.ImageArray.push(ImageArrayObj);
          //localStorage.setItem('Image_Array', JSON.stringify(ImageArrayContent));
          varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment.ScreenshotImages.push(
            ScreenshotImage
          );

          if (self?.isFirefox === "Firefox") {
            self.Uploadfiles(ImageArrayObj);
          } else {
            WriteFileToFileSystem(
              fs,
              ImageArrayObj.FileName,
              ImageArrayObj.Image_Data
            );
          }
        });
        if (fullscreen % 2 != 0) {
          $.ajax({
            url: environment.Violation_Api,
            type: "POST",
            dataType: "json",
            data: {
              ApiKey: environment.api_key,
              CandidateId:
                varCandidateAssessmentData.CandidateAssessmentData.CandidateId,
              RequestId:
                varCandidateAssessmentData.CandidateAssessmentData
                  .AssessmentRequestId,
              ViolationCode: "APP_SWITCHING",
            },
            success: function (data) {},
          });
          if (exit_full_screen > 4) {
            exit_full_screen = 0;
          }
          exit_full_screen += 1;
          $("#popup").css({
            opacity: 1,
          });
          if (exit_full_screen == 4) {
            document.getElementById("message").innerHTML =
              "<h1>" +
              "You cannot leave Full Screen Mode<br><br>You have no attempts left<br>" +
              "</h1>";
          } else if (exit_full_screen < 4) {
            document.getElementById("message").innerHTML =
              "<h1>" +
              "You cannot leave Full Screen Mode<br><br>You only have " +
              (4 - exit_full_screen) +
              " chances left<br>" +
              "</h1>";
          }
          $(".fullscreen-container").fadeTo(200, 1);
          $("#ok").click(function () {
            if (exit_full_screen < 4) {
              $("#popup").css({
                opacity: 0,
              });
              $(".fullscreen-container").fadeOut(200);
              var docElm = document.documentElement;
              $(document).ready(function () {
                if (docElm.requestFullscreen) {
                  docElm.requestFullscreen();
                }
              });
            } else if (exit_full_screen >= 4) {
              $("#popup").css({
                opacity: 1,
                display: "block",
              });
              document.getElementById("message").innerHTML =
                "<h1>" + "You have violated the rules<br>" + "</h1>";
              $(".fullscreen-container").fadeTo(200, 1);
              $("#ok").click(function () {
                exit_full_screen = 0;
                fullscreen = 0;
                route.navigate(["login"]);
              });
            }
          });
        }
      })
    );

    //screenshot for every 30 sec
    id1 = setInterval(() => {
      html2canvas(document.body).then(function (canvas: any) {
        var ScreenshotImage = {
          Filename: "",
          TimeStamp: "",
          Latitude: "",
          Longitude: "",
        };
        ScreenshotImage.Filename =
          "REG" +
          varCandidateAssessmentData.CandidateAssessmentData.RegistrationId +
          "_PracticalScreenShot_" +
          moment().format("YYYYMMDDhhmmss") +
          ".jpeg";
        ScreenshotImage.TimeStamp = moment().format("DD-MMM-YYYY h:mm:ss a");
        ScreenshotImage.Latitude = lat as string;
        ScreenshotImage.Longitude = long as string;
        ImageArrayObj = {
          FileName: "",
          Image_Data: "",
        };
        ImageArrayObj.FileName = ScreenshotImage.Filename;
        ImageArrayObj.Image_Data = canvas.toDataURL("image/jpeg");
        //ImageArrayContent.ImageArray.push(ImageArrayObj);
        //localStorage.setItem('Image_Array', JSON.stringify(ImageArrayContent));
        varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment.ScreenshotImages.push(
          ScreenshotImage
        );

        if (self?.isFirefox === "Firefox") {
          self.Uploadfiles(ImageArrayObj);
        } else {
          WriteFileToFileSystem(
            fs,
            ImageArrayObj.FileName,
            ImageArrayObj.Image_Data
          );
        }
      });
      localStorage.setItem("Response_data", JSON.stringify(data));
    }, 30000);
    //let classify = this.classifyImage;

    //snapshot for every 30 sec
    if (!sessionStorage.getItem("NoWebCamFound")) {
      navigator.getUserMedia(
        constraints,
        function (stream) {
          let video = <HTMLVideoElement>document.getElementById("video");
          video.srcObject = stream;
          localstream = stream;
          //classify(video);
          id2 = setInterval(() => {
            var canvas_vid = <HTMLCanvasElement>(
              document.getElementById("canvas")
            );
            canvas_vid.width = video.videoWidth;
            canvas_vid.height = video.videoHeight;
            canvas_vid.getContext("2d").drawImage(video, 0, 0);
            var varcanvas = canvas_vid.toDataURL("image/jpeg");
            if (video.srcObject != null) {
              var SnapshotImage = {
                Filename: "",
                TimeStamp: "",
                Latitude: "",
                Longitude: "",
              };
              SnapshotImage.Filename =
                "REG" +
                varCandidateAssessmentData.CandidateAssessmentData
                  .RegistrationId +
                "_PracticalSnapShot_" +
                moment().format("YYYYMMDDhhmmss") +
                ".jpeg";
              SnapshotImage.TimeStamp = moment().format(
                "DD-MMM-YYYY h:mm:ss a"
              );
              SnapshotImage.Latitude = lat as string;
              SnapshotImage.Longitude = long as string;
              ImageArrayObj = {
                FileName: "",
                Image_Data: "",
              };
              ImageArrayObj.FileName = SnapshotImage.Filename;
              ImageArrayObj.Image_Data = varcanvas;
              //ImageArrayContent.ImageArray.push(ImageArrayObj);
              //localStorage.setItem('Image_Array', JSON.stringify(ImageArrayContent));
              varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment.SnapshotImages.push(
                SnapshotImage
              );
              if (self?.isFirefox === "Firefox") {
                self.Uploadfiles(ImageArrayObj);
              } else {
                WriteFileToFileSystem(
                  fs,
                  ImageArrayObj.FileName,
                  ImageArrayObj.Image_Data
                );
              }
            }
            localStorage.setItem("Response_data", JSON.stringify(data));
          }, 30000);
        },
        function (err) {
          console.log("Error", err);
        }
      );
    }
  }

  isFileUploaded = false;
  isQuestionAnswered(secIn, indexIn) {
    this.showUploadInput = false;
    this.isFileUploaded = false;
    let textData = JSON.parse(localStorage.getItem("Response_data"));
    var list =
      textData.CandidateAssessmentData.PracticalAssessment.Sections[secIn]
        .Questions[indexIn]?.CandidateResponseEvidenceList;

    var VideoName =
      textData.CandidateAssessmentData.PracticalAssessment.Sections[secIn]
        .Questions[indexIn]?.CandidateResponseVideoFileName;

    if (list?.length || VideoName) {
      document.getElementById("fileUpload").innerHTML =
        "Already Video/File Uploaded for this question.";
      var sections = "sec" + (secIn + 1) + "_" + (indexIn + 1);
      console.log("sections", sections);

      document.getElementById(sections).className = "btn btn-success px-3";
    } else {
      document.getElementById("fileUpload").innerHTML = "";
    }
  }

  initial() {
    var data = this.data;

    console.log(
      "data.CandidateAssessmentData.PracticalAssessment.Sections[sec]",
      data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
    );

    index = 0;

    this.isQuestionAnswered(sec, index);
    let video = "video" + (sec + 1) + "_" + (index + 1);
    document.getElementById(video).style.display = "block";
    $(document).ready(function () {
      document.getElementById("question").innerHTML =
        count +
        ". " +
        data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
          .Questions[index].QuestionTextList[0] +
        " &emsp;<b>[" +
        data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
          .Questions[index].QuestionMarks +
        "] Marks </b>";
      if (sec != 0) {
        var key: string = "";
        $(document).keydown(function (e) {
          key = e.key;
        });
        Event_log("NEXT_BUTTON_CLICKED", data, sec, index, key);
      }
      if (id > 0 && sec != 0) {
        $("#previous").removeAttr("disabled");
        document.getElementById("question").innerHTML +=
          "<br/>" +
          "    " +
          '<font color="maroon" size="4">' +
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions[index].QuestionTextList[id] +
          "</font>";
      }
    });

    $(function () {
      $("#dropdown").change(function () {
        if (id == 0) {
          option = $("#dropdown option:selected").attr("id");
          if (option == "Hindi") id = 1;
          else if (option == "Tamil") id = 2;
          else if (option == "Telugu") id = 3;
          else if (option == "Kannada") id = 4;
          else if (option == "Gujarati") id = 5;
          else if (option == "Oriya") id = 6;
          else if (option == "Assamese") id = 7;
          else if (option == "Urdu") id = 8;
          else if (option == "Marathi") id = 9;
          else if (option == "Malayalam") id = 10;
          else if (option == "Bengali") id = 11;
          else if (option == "Punjabi") id = 12;
          else if (option == "Manipuri") id = 13;
          else id = 0;
          if (id == 0) {
            document.getElementById("question").innerHTML =
              count +
              ". " +
              data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
                .Questions[index].QuestionTextList[id] +
              " &emsp;<b>[" +
              data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
                .Questions[index].QuestionMarks +
              "] Marks </b>";
          } else if (id != 0) {
            document.getElementById("question").innerHTML +=
              "<br/>" +
              "    " +
              '<font color="maroon" size="4">' +
              data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
                .Questions[index].QuestionTextList[id] +
              "</font>";
          }
        } else if (id > 0) {
          option = $("#dropdown option:selected").attr("id");
          if (option == "Hindi") id = 1;
          else if (option == "Tamil") id = 2;
          else if (option == "Telugu") id = 3;
          else if (option == "Kannada") id = 4;
          else if (option == "Gujarati") id = 5;
          else if (option == "Oriya") id = 6;
          else if (option == "Assamese") id = 7;
          else if (option == "Urdu") id = 8;
          else if (option == "Marathi") id = 9;
          else if (option == "Malayalam") id = 10;
          else if (option == "Bengali") id = 11;
          else if (option == "Punjabi") id = 12;
          else if (option == "Manipuri") id = 13;
          else id = 0;
          if (id == 0) {
            document.getElementById("question").innerHTML =
              count +
              ". " +
              data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
                .Questions[index].QuestionTextList[id] +
              " &emsp;<b>[" +
              data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
                .Questions[index].QuestionMarks +
              "] Marks </b>";
          } else if (id != 0) {
            document.getElementById("question").innerHTML =
              count +
              ". " +
              data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
                .Questions[index].QuestionTextList[0] +
              "<br/>" +
              "     " +
              '<font color="maroon" size="4">' +
              data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
                .Questions[index].QuestionTextList[id] +
              "</font>";
          }
        }
      });
    });

    if (
      sec + 1 ==
        data.CandidateAssessmentData.PracticalAssessment.Sections.length &&
      index + 1 ==
        data.CandidateAssessmentData.PracticalAssessment.Sections[sec].Questions
          .length
    )
      $("#next").attr("disabled", "disabled");

    // var sections = "sec" + (sec + 1) + "_" + (index + 1);
    // if (document.getElementById(sections).className == "btn btn-warning px-3")
    //   $("#checkbox").prop("checked", true);
    // else $("#checkbox").prop("checked", false);

    $(function () {
      $("#img").css("display", "none");
      if (
        data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
          .Questions[index].QuestionImageFileName != ""
      ) {
        var link: string =
          environment.Question_Image_URL +
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions[index].QuestionImageFileName;

        $("#img").attr("src", link);
        $("#img").css("display", "block");
      }
      $("#img").click(function () {
        $("#myModal").css("display", "block");
        let src = $("#img").attr("src");
        $("#img01").attr("src", src);
      });
      var span = <HTMLSpanElement>document.getElementsByClassName("close")[0];

      span.onclick = function () {
        $("#myModal").css("display", "none");
      };
    });

    cam(this.data, sec, index);
  }

  next() {
    this.revert();
    let video = "video" + (sec + 1) + "_" + (index + 1);
    document.getElementById(video).style.display = "none";
    var data = this.data;
    index += 1;
    count += 1;
    this.storeData(sec, index, count);

    if (
      index <
      data.CandidateAssessmentData.PracticalAssessment.Sections[sec].Questions
        .length
    ) {
      var key: string = "";
      $(document).keydown(function (e) {
        key = e.key;
      });
      Event_log("NEXT_BUTTON_CLICKED", data, sec, index, key);
      cam(this.data, sec, index);
      if (id > 0) {
        document.getElementById("question").innerHTML =
          count +
          ". " +
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions[index].QuestionTextList[0] +
          "<br/>" +
          "      " +
          '<font color="maroon" size="4">' +
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions[index].QuestionTextList[id] +
          "</font>";
      } else if (id == 0) {
        document.getElementById("question").innerHTML =
          count +
          ". " +
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions[index].QuestionTextList[0] +
          " &emsp;<b>[" +
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions[index].QuestionMarks +
          "] Marks </b>";
      }
      if (
        sec + 1 ==
          data.CandidateAssessmentData.PracticalAssessment.Sections.length &&
        index + 1 ==
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions.length
      ) {
        this.storeData(sec, index, count);
        $("#next").attr("disabled", "disabled");
      }
    } else {
      sec += 1;
      $("#previous").removeAttr("disabled");
      if (
        sec < data.CandidateAssessmentData.PracticalAssessment.Sections.length
      ) {
        this.storeData(sec, index, count);

        this.initial();
      }
    }

    $(function () {
      $("#dropdown").change(function () {
        option = $("#dropdown option:selected").attr("id");
        if (option == "Hindi") id = 1;
        else if (option == "Tamil") id = 2;
        else if (option == "Telugu") id = 3;
        else if (option == "Kannada") id = 4;
        else if (option == "Gujarati") id = 5;
        else if (option == "Oriya") id = 6;
        else if (option == "Assamese") id = 7;
        else if (option == "Urdu") id = 8;
        else if (option == "Marathi") id = 9;
        else if (option == "Malayalam") id = 10;
        else if (option == "Bengali") id = 11;
        else if (option == "Punjabi") id = 12;
        else if (option == "Manipuri") id = 13;
        else id = 0;
      });
    });

    var sections = "sec" + (sec + 1) + "_" + (index + 1);
    if (document.getElementById(sections).className == "btn btn-warning px-3")
      $("#checkbox").prop("checked", true);
    else $("#checkbox").prop("checked", false);

    $("#img").css("display", "none");
    $(function () {
      if (
        data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
          .Questions[index].QuestionImageFileName != ""
      ) {
        var link: string =
          environment.Question_Image_URL +
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions[index].QuestionImageFileName;

        $("#img").attr("src", link);
        $("#img").css("display", "block");
      }
      $("#img").click(function () {
        $("#myModal").css("display", "block");
        let src = $("#img").attr("src");
        $("#img01").attr("src", src);
      });
      var span = <HTMLSpanElement>document.getElementsByClassName("close")[0];

      // When the user clicks on <span> (x), close the modal
      span.onclick = function () {
        $("#myModal").css("display", "none");
      };
    });

    this.isQuestionAnswered(sec, index);
  }
  previous() {
    this.revert();
    var video = "video" + (sec + 1) + "_" + (index + 1);
    document.getElementById(video).style.display = "none";
    video = "video" + sec + "_" + (index + 1);
    document.getElementById(video).style.display = "block";
    $("#next").removeAttr("disabled");
    var data = this.data;
    if (index !== 0) {
      index -= 1;
      count -= 1;
      this.storeData(sec, index, count);
    } else if (index == 0) {
      if (sec != 0) {
        sec -= 1;
        this.storeData(sec, index, count);
      }
      if (sec >= 0) {
        index =
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions.length - 1;
        count -= 1;
        this.storeData(sec, index, count);
      }
    }
    if (index >= 0) {
      var key: string = "";
      $(document).keydown(function (e) {
        key = e.key;
      });
      Event_log("PREVIOUS_BUTTON_CLICKED", data, sec, index, key);
      if (id > 0) {
        document.getElementById("question").innerHTML =
          count +
          ". " +
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions[index].QuestionTextList[0] +
          " &emsp;<b>[" +
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions[index].QuestionMarks +
          "] Marks </b>" +
          "<br/>" +
          "     " +
          '<font color="maroon" size="4">' +
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions[index].QuestionTextList[id] +
          " &emsp;<b>[" +
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions[index].QuestionMarks +
          "] Marks </b>" +
          "</font>";
      } else if (id == 0) {
        document.getElementById("question").innerHTML =
          count +
          ". " +
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions[index].QuestionTextList[0] +
          " &emsp;<b>[" +
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions[index].QuestionMarks +
          "] Marks </b>";
      }
    }
    $(function () {
      $("#dropdown").change(function () {
        option = $("#dropdown option:selected").attr("id");
        if (option == "Hindi") id = 1;
        else if (option == "Tamil") id = 2;
        else if (option == "Telugu") id = 3;
        else if (option == "Kannada") id = 4;
        else if (option == "Gujarati") id = 5;
        else if (option == "Oriya") id = 6;
        else if (option == "Assamese") id = 7;
        else if (option == "Urdu") id = 8;
        else if (option == "Marathi") id = 9;
        else if (option == "Malayalam") id = 10;
        else if (option == "Bengali") id = 11;
        else if (option == "Punjabi") id = 12;
        else if (option == "Manipuri") id = 13;
        else id = 0;
      });
    });
    if (sec == 0 && index == 0) {
      $("#previous").attr("disabled", "disabled");
    }
    var sections = "sec" + (sec + 1) + "_" + (index + 1);
    if (document.getElementById(sections).className == "btn btn-warning px-3")
      $("#checkbox").prop("checked", true);
    else $("#checkbox").prop("checked", false);

    $("#img").css("display", "none");
    if (
      data.CandidateAssessmentData.PracticalAssessment.Sections[sec].Questions[
        index
      ].QuestionImageFileName != ""
    ) {
      var link: string =
        environment.Question_Image_URL +
        data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
          .Questions[index].QuestionImageFileName;

      $("#img").attr("src", link);
      $("#img").css("display", "block");
    }
    $("#img").click(function () {
      $("#myModal").css("display", "block");
      let src = $("#img").attr("src");
      $("#img01").attr("src", src);
    });
    var span = <HTMLSpanElement>document.getElementsByClassName("close")[0];

    // When the user clicks on <span> (x), close the modal
    span.onclick = function () {
      $("#myModal").css("display", "none");
    };

    cam(this.data, sec, index);
    this.isQuestionAnswered(sec, index);
  }

  clicked(section: string, ind: string, question: string) {
    document.getElementById("fileuploadBox").style.display = "none";
    let textData = JSON.parse(localStorage.getItem("Response_data"));

    var list =
      textData.CandidateAssessmentData.PracticalAssessment.Sections[sec]
        .Questions[index]?.CandidateResponseEvidenceList;

    var VideoName =
      textData.CandidateAssessmentData.PracticalAssessment.Sections[sec]
        .Questions[index]?.CandidateResponseVideoFileName;

    if (list?.length || VideoName) {
      document.getElementById("fileUpload").innerHTML =
        "Already Video/File Uploaded for this question.";
    } else {
      document.getElementById("fileUpload").innerHTML = "";
    }

    $(function () {
      var no1 =
        varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
          .Sections.length;
      var no2 =
        varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
          .Sections[no1 - 1].Questions.length;
      no1 = no1.toString();
      no2 = no2.toString();
      for (
        var i = 0;
        i <
        parseInt(
          varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
            .Sections.length
        );
        i++
      ) {
        var tag = "video" + (i + 1) + "_" + ind;
        document.getElementById(tag).style.display = "none";
      }
      //var video = 'video' + section + '_' + ind;
      //document.getElementById(video).style.display = 'block';
      var sections = "sec" + section + "_" + ind;

      if (document.getElementById(sections).className == "btn btn-warning px-3")
        $("#checkbox").prop("checked", true);
      else $("#checkbox").prop("checked", false);
      $("#next").removeAttr("disabled");
      $("#previous").removeAttr("disabled");
      if (section == "1" && ind == "1")
        $("#previous").attr("disabled", "disabled");
      if (section == no1 && ind == no2) $("#next").attr("disabled", "disabled");
      count = parseInt(question);
      index = parseInt(ind) - 1;
      sec = parseInt(section) - 1;

      var list =
        varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
          .Sections[sec].Questions[index]?.CandidateResponseEvidenceList;

      var VideoName =
        varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
          .Sections[sec].Questions[index]?.CandidateResponseVideoFileName;

      console.log("list", list, VideoName);

      if (list?.length || VideoName) {
        document.getElementById("fileUpload").innerHTML =
          "Already Video/File Uploaded for this question.";
      } else {
        document.getElementById("fileUpload").innerHTML = "";
      }

      varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment.CurrentSectionIndex =
        sec;
      varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment.CurrentQuestionIndex =
        index;
      varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment.CurrentQuestionCount =
        count;
      localStorage.setItem(
        localStorage.getItem("req_id") +
          "_" +
          localStorage.getItem("cand_id") +
          "_" +
          "data",
        JSON.stringify(varCandidateAssessmentData)
      );

      if (id == 0) {
        document.getElementById("question").innerHTML =
          question +
          ". " +
          varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
            .Sections[sec].Questions[index].QuestionTextList[0] +
          " &emsp;<b>[" +
          varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
            .Sections[sec].Questions[index].QuestionMarks +
          "] Marks </b>";
      } else if (id != 0) {
        document.getElementById("question").innerHTML =
          question +
          ". " +
          varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
            .Sections[sec].Questions[index].QuestionTextList[0] +
          "<br/>" +
          "      " +
          '<font color="maroon" size="4">' +
          varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
            .Sections[sec].Questions[index].QuestionTextList[id] +
          "</font>";
      }
      var key: string = "";
      $(document).keydown(function (e) {
        key = e.key;
      });
      Event_log(
        "QUESTION_LINK_CLICKED",
        varCandidateAssessmentData,
        sec,
        index,
        key
      );

      $("#img").css("display", "none");
      if (
        varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
          .Sections[sec].Questions[index].QuestionImageFileName != ""
      ) {
        var link: string =
          environment.Question_Image_URL +
          varCandidateAssessmentData.CandidateAssessmentData.PracticalAssessment
            .Sections[sec].Questions[index].QuestionImageFileName;
        $("#img").attr("src", link);
        $("#img").css("display", "block");
      }
      $("#img").click(function () {
        $("#myModal").css("display", "block");
        let src = $("#img").attr("src");
        $("#img01").attr("src", src);
      });
      var span = <HTMLSpanElement>document.getElementsByClassName("close")[0];

      // When the user clicks on <span> (x), close the modal
      span.onclick = function () {
        $("#myModal").css("display", "none");
      };

      cam(varCandidateAssessmentData, parseInt(section) - 1, parseInt(ind) - 1);
    });
  }

  /*marked() {
    var data = JSON.parse(localStorage.getItem('Response_data'));
    var section = 'sec' + (sec + 1) + '_' + (index + 1);
    if ($('#checkbox').is(':checked')) {
      marked_review += 1;
      var key: string = '';
      $(document).keydown(function (e) {
        key = e.key;
      });
      Event_log(
        'QUESTION_MARKED_FOR_REVIEW',
        data,
        sec,
        index,
        key
      );
      document.getElementById(section).className = 'btn btn-warning px-3';
    } else {
      document.getElementById(section).classList.remove('btn-warning');
      var key: string = '';
      $(document).keydown(function (e) {
        key = e.key;
      });
      Event_log(
        'QUESTION_UNMARKED_FOR_REVIEW',
        data,
        sec,
        index,
        key
      );
      if (
        parseInt(
          data.CandidateAssessmentData.PracticalAssessment.Sections[sec]
            .Questions[index].CandidateActualResponseOption
        ) != -1
      ) {
        document.getElementById(section).className = 'btn btn-success px-3';
        marked_review -= 1;
      } else {
        document.getElementById(section).className = 'btn btn-danger px-3';
        marked_review -= 1;
      }
    }
  }*/

  notify = "";
  timeup(event: any) {
    this.data.CandidateAssessmentData.PracticalAssessment.RemainingDurationSeconds =
      (event.left as number) / 1000;
    localStorage.setItem(
      localStorage.getItem("req_id") +
        "_" +
        localStorage.getItem("cand_id") +
        "_" +
        "data",
      JSON.stringify(this.data)
    );

    this.notify = event.action.toUpperCase();
    if (event.action === "notify" && event.left === 120) {
      this.notify += ` - ${event.left} ms`;
      alert("You had only two min left to finish the examinations ");
    }

    if (event.action == "done") {
      timer = true;
      if (id1) {
        clearInterval(id1);
      }
      if (id2) {
        clearInterval(id2);
      }
      if (id3) {
        clearInterval(id3);
      }
      localstream.stop();
      $("body").off();
      document.removeEventListener("contextmenu", id4);
      document.removeEventListener("fullscreenchange", full_screen);
      document.removeEventListener("visibilitychange", visibility);
      $("#submit_reponse_btn").click();
    }
  }

  submit() {
    attempted_count = 0;
    let total_question = 0;
    var data = this.data;
    $.each(
      data.CandidateAssessmentData.PracticalAssessment.Sections,
      function (index: number, value) {
        total_question +=
          data.CandidateAssessmentData.PracticalAssessment.Sections[index]
            .Questions.length;
        $.each(
          data.CandidateAssessmentData.PracticalAssessment.Sections[index]
            .Questions,
          function (ind: number, val) {
            var section = "sec" + (index + 1) + "_" + (ind + 1);
            if (
              document.getElementById(section).className ==
              "btn btn-success px-3"
            ) {
              attempted_count += 1;
            }
          }
        );
      }
    );
    $(document).ready(function () {
      if (timer) {
        document.getElementById("1").innerHTML =
          "<h2 style='color:red'>TIME UP</h2><br>" +
          "<h2>Total questions : " +
          total_question +
          " questions <br></h2>" +
          "<h2>Attempted questions : " +
          attempted_count +
          " questions <br></h2>" +
          "<h2>Unattempted questions : " +
          (total_question - attempted_count) +
          " questions <br></h2>";
        $("#no").attr("disabled", "disabled");
      } else {
        document.getElementById("1").innerHTML =
          "<h2>Total questions : " +
          total_question +
          " questions <br></h2>" +
          "<h2>Attempted questions : " +
          attempted_count +
          " questions <br></h2>" +
          "<h2>Unattempted questions : " +
          (total_question - attempted_count) +
          " questions <br></h2>";
      }
    });
  }

  yes() {
    var data = JSON.parse(localStorage.getItem(this.Req + "_" + this.Id + "_" + "data"));
    if (
      data.CandidateAssessmentData.PracticalAssessment
        .AssessmentFinishDateTime == ""
    )
      data.CandidateAssessmentData.PracticalAssessment.AssessmentFinishDateTime =
        moment().format("DD-MMM-YYYY h:mm:ss a");
    var key: string = "";
    $(document).keydown(function (e) {
      key = e.key;
    });
    Event_log("ASSESSMENT_FINISHED", data, sec, index, key);
    data.CandidateAssessmentData.PracticalAssessment.AssessmentStatusId =
      environment.ASSESSMENT_FINISHED;
    localStorage.setItem(this.Req + "_" + this.Id + "_" + "data", JSON.stringify(data));
    if (!sessionStorage.getItem("NoWebCamFound"))
      this.route.navigate(["end-image-capture"]);
    else this.route.navigate(["feedback-practical"]);
  }

  ngOnDestroy() {
    if (id1) {
      clearInterval(id1);
    }
    if (id2) {
      clearInterval(id2);
    }
    if (id3) {
      clearInterval(id3);
    }
    // localstream.stop();
    $("body").off();
    this.storeData(sec, index, count);
    document.removeEventListener("contextmenu", id4);
    document.removeEventListener("fullscreenchange", full_screen);
    document.removeEventListener("keydown", visibility);
  }
}

function WriteFileToFileSystem(varFs: any, fileName: any, fileContent: any) {
  varFs.root.getFile(
    "/" + fileName,
    { create: true },
    function (fileEntry: any) {
      // Create a FileWriter object for our FileEntry (log.txt).
      fileEntry.createWriter(function (fileWriter: any) {
        fileWriter.onwriteend = function (e: any) {
          console.log("Write completed.");
        };

        fileWriter.onerror = function (e: any) {
          console.log("Write failed: " + e.toString());
        };

        var blob = new Blob([fileContent], { type: "text/plain" });

        fileWriter.write(blob);
      }, errorHandler);
    },
    errorHandler
  );
}
function errorHandler(err: any) {
  console.log(err);
}

function Event_log(
  events: string,
  data: any,
  sec: number,
  index: number,
  key: string
) {
  let lat = localStorage.getItem("lat");
  let long = localStorage.getItem("long");
  var Assessment_event = {
    DateTime: moment().format("DD-MMM-YYYY h:mm:ss a"),
    SubTypeId: 0,
    SectionIndex: sec,
    QuestionIndex: index,
    Response: -1,
    KeyboardKey: key,
    Description: "",
    EventImage: "",
    Latitude: lat,
    Longitude: long,
  };
  switch (events) {
    case "ASSESSMENT_STARTED":
      Assessment_event.SubTypeId = 1;
      Assessment_event.Description = "Candidate has started the assessment";
      break;
    case "ASSESSMENT_CONTINUED":
      Assessment_event.SubTypeId = 2;
      Assessment_event.Description = "Candidate has continued the assessment";
      break;
    case "ASSESSMENT_FINISHED":
      Assessment_event.SubTypeId = 3;
      Assessment_event.Description = "Candidate has finished the assessment";
      break;
    case "ASSESSMENT_DATA_UPLOAD_FAILED":
      Assessment_event.SubTypeId = 4;
      Assessment_event.Description = "Upload failed";
      break;
    case "ASSESSMENT_DATA_UPLOADED":
      Assessment_event.SubTypeId = 5;
      Assessment_event.Description = "Upload successful";
      break;
    case "ASSESSMENT_SUBMITTED":
      Assessment_event.SubTypeId = 7;
      Assessment_event.Description = "Assessment Submitted";
      break;
    case "QUESTION_LINK_CLICKED":
      Assessment_event.SubTypeId = 12;
      Assessment_event.Description = "Candidate has clicked question link";
      break;
    case "PREVIOUS_BUTTON_CLICKED":
      Assessment_event.SubTypeId = 13;
      Assessment_event.Description = "Candidate has clicked previous button";
      break;
    case "NEXT_BUTTON_CLICKED":
      Assessment_event.SubTypeId = 14;
      Assessment_event.Description = "Candidate has clicked next button";
      break;
    case "QUESTION_LANGUAGE_CHANGED":
      Assessment_event.SubTypeId = 15;
      Assessment_event.Description = "Candidate has changed the language";
      break;
    case "QUESTION_MARKED_FOR_REVIEW":
      Assessment_event.SubTypeId = 17;
      Assessment_event.Description =
        "Candidate has marked the question for review";
      break;
    case "QUESTION_UNMARKED_FOR_REVIEW":
      Assessment_event.SubTypeId = 18;
      Assessment_event.Description = "Candidate has unmarked the review";
      break;
    case "OPTION_SELECTED":
      Assessment_event.SubTypeId = 21;
      break;
    case "KEYBOARD_KEY_PRESSED":
      Assessment_event.SubTypeId = 23;
      break;
    case "EXIT_FULLSCREEN":
      Assessment_event.SubTypeId = 25;
      Assessment_event.Description = "Candidate attempted to exit full screen";
      Assessment_event.EventImage = EventImage;
      break;
    case "TAB_SWITCH":
      Assessment_event.SubTypeId = 25;
      Assessment_event.Description = "Candidate attempted to switch tabs";
      Assessment_event.EventImage = EventImage;
      break;
  }
  data.CandidateAssessmentData.PracticalAssessment.AssessmentEvents.push(
    Assessment_event
  );
  var file =
    localStorage.getItem("req_id") +
    "_" +
    localStorage.getItem("cand_id") +
    "_" +
    "data";
  if (typeof data == "string") localStorage.setItem(file, JSON.stringify(data));
  else localStorage.setItem(file, JSON.stringify(data));
  localStorage.setItem("Response_data", JSON.stringify(data));
}

function Finish_check(json_data: any) {
  let count = 0;
  json_data.CandidateAssessmentData.PracticalAssessment.Sections.forEach(
    (elt: any, index: any) => {
      elt.Questions.forEach((item: any, ind: any) => {
        console.log("item", item);

        if (item.CandidateResponseEvidenceList) {
          if (
            item.CandidateResponseVideoFileName == "" &&
            item.CandidateResponseEvidenceList.length === 0
          ) {
            count = count + 1;
          }
        }
      });
    }
  );
  console.log("count", count);
  $("#submit_reponse_btn").removeAttr("disabled");

  // if (count == 0) {
  //   $("#submit_reponse_btn").removeAttr("disabled");
  // }
}

var isMobile = {
  any: function () {
    if (
      /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      return true;
    } else {
      return false;
    }
  },
};
